import type { Category as SearchTabCategory } from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/types";
import type { Category as UuidCategory } from "../types";

// Default categories coming from CMS doesn't have a key, so we need to extract it from the label
function extractCategoryKey(categoryLabel: string): string {
  const mappedCategories = {
    "Bachelor's Degrees": "bachelors",
    "Master's Degrees": "masters",
    Certificates: "certificate",
    "Executive Education": "executiveEducation",
    Courses: "courses",
  };
  return (
    mappedCategories[categoryLabel as keyof typeof mappedCategories] ??
    categoryLabel.toLowerCase().replace(/\s+/g, "").replace("'sdegrees", "s")
  );
}

export const mapUuidTabsToSearchTabCategories = (
  categories: UuidCategory[],
): SearchTabCategory[] =>
  categories.map((c) => ({
    categoryKey: extractCategoryKey(c.categoryLabel),
    productType: c.productType,
    categoryLabel: c.categoryLabel,
    additionalProductTypes: [],
    subcategories:
      c.subcategories?.map((sc) => ({
        subcategoryLabel: sc.subcategoryLabel,
        productUuids: [],
        searchUrl: sc.searchUrl,
        ctaLabel: sc.ctaLabel,
        ctaUrl: sc.ctaUrl,
      })) ?? [],
  }));
